import { useTheme } from '@mui/material';
import Dropdown from 'components/buttons/Dropdown';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useConfig } from 'hooks';
import Cookies from 'js-cookie';
import { getBrandUISettings } from 'lib/utilities/Brands';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { Container, Label } from './ListCurrency.styled';

const ListCurrency = () => {
	const { baseUrl, brand } = useConfig();
	const router = useRouter();
	const { query } = router;
	const { updateOtherParamsString, applyFilters, additionalParamsApplied, udpateSelectedCurrency, locale, globalization } =
		useContext(CruiseSearchContext);

	const { palette } = useTheme();
	const { uiSettings } = getBrandUISettings(brand.code);

	const { generalDictionary } = globalization?.dictionaries || {};
	const { labelCurrency } = generalDictionary;

	const { currencies: listCurrencies, currency: code } = locale || {};

	const singleCurrency = Boolean(listCurrencies.length <= 1);
	const options = (listCurrencies || []).map((val) => {
		return {
			label: val,
			code: val,
		};
	});

	const onChangeCurrency = (locale) => {
		Cookies.set('currency', locale.code, {
			domain: baseUrl.replace('https://www', ''),
		});
		udpateSelectedCurrency(locale.code);
		updateOtherParamsString({ ...query, currency: locale.code }, additionalParamsApplied, applyFilters);
	};

	if (!singleCurrency)
		return (
			<Container data-testid="country-currency-label">
				<Label component="span" variant="title2" palette={palette} styles={uiSettings.resultsHeader.labels}>
					<span>{labelCurrency}:</span>
				</Label>
				<Dropdown
					label={code}
					onChange={onChangeCurrency}
					options={options}
					scrollerId={'default'}
					buttonStyleText
					select
					disabled={singleCurrency}
				/>
			</Container>
		);
	else return <></>;
};

export default ListCurrency;
